var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.userProfile)?_c('BaseNavBar'):_vm._e(),_c('h1',{directives:[{name:"show",rawName:"v-show",value:(_vm.userProfile),expression:"userProfile"}],staticClass:"title"},[_vm._v(" Add New Participant ")]),_c('CreateParticipant',{class:{ 'main-section': !_vm.userProfile }})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }